export const STARS_IMAGE_PROPS = {
    cloudinaryHeight: 32,
    cloudinaryWidth: 32,
    width: "16px",
    height: "16px",
    alt: "stars",
    cloudinaryId: "portal/m/coupon_stars.png",
};

export const NEW_BADGE_LOTTIE_COMPONENT_PROPS = {
    loop: true,
    autoplay: true,
    backwardSpeed: 1,
    forwardSpeed: 1,
    playIfVisible: false,
};
